import * as Sentry from '@sentry/browser';
import { ShowErrorAlert } from './utils/ShowErrorAlert';
import { ShowReportDialog } from './utils/ShowReportDialog';
import { isDev } from "./utils/common";
/**
 * @description ErrorsCapture gets errors from api or ui and
 * generates a message sending to Sentry and sets alerts
 * @param {TSentryParams} params
 *
 */
export var ErrorsCapture = function (params) {
    var error = params.error, _a = params.errorLevel, errorLevel = _a === void 0 ? 'Error' : _a, _b = params.tag, tag = _b === void 0 ? 'test' : _b, _c = params.componentName, componentName = _c === void 0 ? '' : _c, _d = params.PathCatchOn, PathCatchOn = _d === void 0 ? '-' : _d, _e = params.MethodCatchOn, MethodCatchOn = _e === void 0 ? '-' : _e, _f = params.AdditionalInfo, AdditionalInfo = _f === void 0 ? '-' : _f, _g = params.ApiUrl, ApiUrl = _g === void 0 ? '-' : _g, RequestType = params.RequestType, _h = params.ErrorReason, ErrorReason = _h === void 0 ? '' : _h, _j = params.ErrorType, ErrorType = _j === void 0 ? '' : _j, RequestPayload = params.RequestPayload, alertDuration = params.alertDuration, alertTitle = params.alertTitle, showAlertReportBtn = params.showAlertReportBtn, isOnlyAlert = params.isOnlyAlert;
    var eventId = '';
    var additionalInfo = {
        ErrorMessage: tag === 'api-request' ? ErrorReason : error.message,
    };
    if (tag === 'api-request') {
        additionalInfo.ApiUrl = ApiUrl;
        additionalInfo.RequestType = RequestType;
        additionalInfo.ErrorReason = ErrorReason;
        additionalInfo.ErrorType = ErrorType;
        additionalInfo.RequestPayload = RequestPayload;
    }
    else if (tag === 'client') {
        additionalInfo.PathCatchOn = PathCatchOn;
        additionalInfo.MethodCatchOn = MethodCatchOn;
        additionalInfo.AdditionalInfo = AdditionalInfo;
    }
    if (isDev()) {
        console.log('ErrorsCapture ApiUrl', ApiUrl);
        console.log('ErrorsCapture ApiUrl without query', ApiUrl === null || ApiUrl === void 0 ? void 0 : ApiUrl.split('?')[0]);
    }
    ShowErrorAlert({
        key: eventId,
        title: alertTitle,
        errorMessage: tag === 'api-request' ? ErrorReason : error.message,
        status: errorLevel,
        duration: alertDuration,
        isClosable: true,
        hasReportBtn: isOnlyAlert ? false : showAlertReportBtn,
        handleReportClick: function (eventId) { return ShowReportDialog(eventId); },
    });
    // если надо было только показать ошибку то выходим из функции
    if (isOnlyAlert)
        return;
    //Формирование дополнительной информации об ошибке
    Sentry.configureScope(function (scope) {
        return scope
            .setFingerprint([tag, String(componentName || ApiUrl)]) //Отпечаток для группировки ошибок
            .setTransactionName("Error on ".concat(tag, ": ").concat(componentName || ApiUrl)) //Название ошибки в Sentry
            .setContext('Context', additionalInfo) //Дополнительная информация (раздел "Context")
            .setTag('error.type', tag);
    });
    //Отправка сообщения с ошибкой в sentry
    eventId = Sentry.captureException(error);
};
